module.exports = __webpack_public_path__ + "img/IMG_2482.bd192ed2.jpg";